// extracted by mini-css-extract-plugin
export default {"otherOperation":"index_otherOperation__sZBD8"};